import {CommonModule, NgOptimizedImage} from '@angular/common';
import {Component, OnInit, signal} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { strictEmailValidator } from "../../utils/validators";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {GlobalConstants} from "../../common/global";

@Component({
  selector: 'app-footer',
  templateUrl: `./${environment.pageFolder}/footer.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/footer.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [
    TranslateModule,
    RouterModule,
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    NgOptimizedImage
  ]
})

export class FooterComponent implements OnInit {
  readonly email = new FormControl('', [strictEmailValidator]);
  readonly errorMessage = signal('');
  isLogged: boolean = false;

  ngOnInit(): void {
    this.isLogged = GlobalConstants.isAuth;
  }

  updateErrorMessage(): void {
    if (this.email.hasError('invalidEmail')) {
      this.errorMessage.set('E-mail adresa nije u ispravnom obliku');
    } else {
      this.errorMessage.set('');
    }
  }

  handleNewsletter(): void {
    if (this.email.value && !this.email.hasError('invalidEmail')) {
      //TODO BE api
    }
  }
}
